import axios from "axios";
import {API_DOMAIN} from "../constants";

const USER_TYPES_URL = API_DOMAIN + "/api/v3/auth/userTypes";
const USER_TYPE_GROUPS_URL = API_DOMAIN + "/api/v3/auth/userTypeGroups";
const APP_EXPERIENCES_URL = API_DOMAIN + "/api/v3/auth/appExperiences";

const authHeader = () => ({Authorization: localStorage.getItem("MFE_TOKEN")});

// GET /api/v3/auth/userTypes[?managedByUserId=]
// Returns [{id, name, displayName, appExperience, managesCount, managedByCount, groupCount}],
// ordered by display name. `name` is the internal key; the label is `displayName`.
// When managedByUserId is supplied, the list is scoped to the user types that user may manage.
export async function getUserTypes(managedByUserId) {
    const response = await axios({
        url: USER_TYPES_URL,
        method: "GET",
        headers: authHeader(),
        params: managedByUserId ? {managedByUserId} : undefined,
    });

    return response.data;
}

// GET /api/v3/auth/userTypes/{id}
// Returns {id, name, displayName, appExperience, manages: [{id, displayName, appExperience}],
// managedBy: [{...}], availableGroups: [{businessUnitCode, defaultGroupId, groups: [{id, name}]}]}.
export async function getUserType(id) {
    const response = await axios({
        url: `${USER_TYPES_URL}/${id}`,
        method: "GET",
        headers: authHeader(),
    });

    return response.data;
}

// POST /api/v3/auth/userTypes  (Global Admin)
// Payload: {name, displayName, appExperience, manages?: [id]}. Returns the summary shape. 409 on
// duplicate name, 400 on unknown app experience or managed-type reference.
export async function createUserType(payload) {
    const response = await axios({
        url: USER_TYPES_URL,
        method: "POST",
        headers: authHeader(),
        data: payload,
    });

    return response.data;
}

// PUT /api/v3/auth/userTypes/{id}  (Global Admin)
// Payload: {displayName, appExperience, manages: [id]}. The internal name is immutable. Available
// groups are managed via setUserTypeGroups, not here. Returns the summary shape.
export async function updateUserType(id, payload) {
    const response = await axios({
        url: `${USER_TYPES_URL}/${id}`,
        method: "PUT",
        headers: authHeader(),
        data: payload,
    });

    return response.data;
}

// PUT /api/v3/auth/userTypeGroups  (Global Admin)
// Payload: {userTypeId, availability: [{businessUnitCode, groupIds: [id], defaultGroupId}]}.
// Replaces the user type's group availability across all business units. 204 on success.
export async function setUserTypeGroups(payload) {
    return axios({
        url: USER_TYPE_GROUPS_URL,
        method: "PUT",
        headers: authHeader(),
        data: payload,
    });
}

// GET /api/v3/auth/appExperiences -> [{name}]
export async function getAppExperiences() {
    const response = await axios({
        url: APP_EXPERIENCES_URL,
        method: "GET",
        headers: authHeader(),
    });

    return response.data;
}
